import {Button, styled} from '@mui/material'

export const CancelButton = styled(Button)((props) => ({
  color: props.theme.palette.action.active
}))
